"use client";

import { create } from "zustand";
import { getStorageData, setStorageData } from "@/_utils";
import {
  DEFAULT_SIDEBAR_THEME,
  isSidebarThemeId,
  SIDEBAR_THEME_STORAGE_KEY,
} from "./themes";
import type { SidebarThemeId } from "./types";

interface SidebarThemeState {
  themeId: SidebarThemeId;
  setThemeId: (themeId: SidebarThemeId) => void;
}

function readStoredThemeId(): SidebarThemeId {
  if (typeof window === "undefined") {
    return DEFAULT_SIDEBAR_THEME;
  }

  const stored = getStorageData<string>(SIDEBAR_THEME_STORAGE_KEY);
  if (stored && isSidebarThemeId(stored)) {
    return stored;
  }

  return DEFAULT_SIDEBAR_THEME;
}

export const useSidebarThemeStore = create<SidebarThemeState>((set) => ({
  themeId: readStoredThemeId(),
  setThemeId: (themeId) => {
    setStorageData(SIDEBAR_THEME_STORAGE_KEY, themeId);
    set({ themeId });
  },
}));
